import { JsonViewer } from '@/ui-kit/json-viewer/JsonViewer';
import { useDashboardConfig } from '@/hooks/useDashboardConfig';

export const DashboardConfiguration = () => {
  const dashboardConfiguration = useDashboardConfig();

  if (!dashboardConfiguration) return null;

  return <JsonViewer src={dashboardConfiguration} />;
};
